import { FunctionComponent } from 'react';
import { IconMinus, IconPlusLarge } from '@tock/icons';
import ControlButton from 'components/profile/culinary-travel-log/ControlButton';
import ControlPanel from 'components/profile/culinary-travel-log/ControlPanel';

export interface Props {
  map: google.maps.Map;
  // Optional callback fired when the user clicks a zoom button — a positive
  // user-gesture signal (distinct from a programmatic `map.setZoom`).
  onUserZoom?(): void;
}

const ZoomControls: FunctionComponent<Props> = ({ map, onUserZoom }) => {
  return (
    <ControlPanel>
      <ControlButton
        onClick={() => {
          map.setZoom((map.getZoom() ?? 0) + 1);
          onUserZoom?.();
        }}
        title="Zoom in"
      >
        <IconPlusLarge />
      </ControlButton>
      <ControlButton
        onClick={() => {
          map.setZoom((map.getZoom() ?? 0) - 1);
          onUserZoom?.();
        }}
        title="Zoom out"
      >
        <IconMinus />
      </ControlButton>
    </ControlPanel>
  );
};

export default ZoomControls;
